import React, { useEffect, useRef, useState } from "react";
import { BannerSearchBar } from "./BannerSearchBar";
import { useDispatch, useSelector } from "react-redux";
import { getPropertyDetail } from "../../../Redux/Slices/BON-Frontend/propertySlice";

export const FormBanner = ({ checkInDate, checkOutDate, }) => {
  const wrapperRef = useRef(null);

  const dispatch = useDispatch();

  const { propertyDetails } = useSelector(
    (state) => state.property
  );

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const pid = params.get("pid");

    if (pid) {
      dispatch(getPropertyDetail(pid));
    }
  }, [dispatch]);

  return (
    <>
      <section
        className="container bp-hero-banner"
        ref={wrapperRef}
      >

        {/* Hero Image + Overlay */}
        <div className="bp-hero-banner-inner">
          <img
            alt="Hotel Banner"
            src={propertyDetails?.PropertySearchBanner}
          />
          <div className="bp-hero-overlay">
            <h3 className="text-white display-6 fw-bold mb-1">
              {propertyDetails?.DisplayName}
            </h3>
            <p className="text-white opacity-75 mb-0 fs-5" style={{ maxWidth: 450 }}>
              Experience the pinnacle of luxury and recreation in the heart of Bhuj.
            </p>
          </div>
        </div>

        <BannerSearchBar
          checkInDate={checkInDate}
          checkOutDate={checkOutDate}
        />
      </section>
    </>
  )
}